// Generic searchable-dropdown enhancer. Works on any [data-combobox] wrapper
// containing a [data-combobox-input] text field and a [data-combobox-list] of
// [data-combobox-option] items — used by both the lead capture modal and the
// product-page quote modal's City / Province field. Markup/classes can differ
// between the two; only these data attributes matter.
(function () {
  function setupCombobox(wrapper) {
    var input = wrapper.querySelector('[data-combobox-input]');
    var list = wrapper.querySelector('[data-combobox-list]');
    if (!input || !list) return;

    var options = Array.prototype.slice.call(list.querySelectorAll('[data-combobox-option]'));
    var activeIndex = -1;

    function visibleOptions() {
      return options.filter(function (option) {
        return !option.hidden;
      });
    }

    function setActiveOption(option) {
      options.forEach(function (candidate) {
        candidate.classList.toggle('is-active', candidate === option);
        candidate.setAttribute('aria-selected', candidate === option ? 'true' : 'false');
      });
      activeIndex = option ? options.indexOf(option) : -1;
      if (option) option.scrollIntoView({ block: 'nearest' });
    }

    function openList() {
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function closeList() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActiveOption(null);
    }

    function filterOptions() {
      var query = input.value.trim().toLowerCase();
      var visibleCount = 0;
      options.forEach(function (option) {
        var match = !query || option.textContent.toLowerCase().indexOf(query) !== -1;
        option.hidden = !match;
        if (match) visibleCount += 1;
      });
      return visibleCount;
    }

    function selectOption(option) {
      input.value = option.textContent.trim();
      closeList();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    input.addEventListener('focus', function () {
      filterOptions();
      openList();
    });

    input.addEventListener('input', function () {
      openList();
      filterOptions();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (list.hidden) {
          filterOptions();
          openList();
        }
        var visible = visibleOptions();
        var currentIndex = visible.indexOf(options[activeIndex]);
        setActiveOption(visible[currentIndex + 1] || visible[0] || null);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        var visibleUp = visibleOptions();
        var currentIndexUp = visibleUp.indexOf(options[activeIndex]);
        setActiveOption(visibleUp[currentIndexUp - 1] || visibleUp[visibleUp.length - 1] || null);
      } else if (event.key === 'Enter') {
        if (!list.hidden && activeIndex > -1) {
          event.preventDefault();
          selectOption(options[activeIndex]);
        }
      } else if (event.key === 'Escape') {
        closeList();
      }
    });

    options.forEach(function (option) {
      // mousedown (not click) fires before the input's blur event, so the
      // list is still open — and its options still in the DOM — when this runs.
      option.addEventListener('mousedown', function (event) {
        event.preventDefault();
        selectOption(option);
      });
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) closeList();
    });
  }

  document.querySelectorAll('[data-combobox]').forEach(setupCombobox);
})();
